import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "settings-printer mb-3"
};
var _hoisted_2 = {
  class: "mb-1"
};
var _hoisted_3 = {
  class: "item-name"
};
var _hoisted_4 = {
  class: "item-name"
};
var _hoisted_5 = {
  class: "item-name"
};
var _hoisted_6 = {
  class: "item-name"
};
var _hoisted_7 = {
  class: "item-name"
};
var _hoisted_8 = {
  class: "item-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("settings.tickets-emails.title")), 1), _createVNode(_component_el_form, {
    model: _ctx.formData,
    "label-position": "top",
    "label-width": "120px",
    "hide-required-asterisk": true,
    class: "setting-items"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("printersettings.title")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: _ctx.printerOption.auto ? 'primary' : 'default',
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.toggleStatus(true);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.auto")), 1)];
                }),
                _: 1
              }, 8, ["type"]), _createVNode(_component_el_button, {
                type: _ctx.printerOption.auto ? 'default' : 'primary',
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.toggleStatus(false);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.manual")), 1)];
                }),
                _: 1
              }, 8, ["type"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("printersettings.ticket-type")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                class: "w-100"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _ctx.selectedTicketType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return _ctx.selectedTicketType = $event;
                    }),
                    placeholder: _ctx.$t('select.ticket-type')
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketTypesArray, function (ticketType) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: ticketType.value,
                          label: ticketType.label,
                          value: ticketType.value
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("printersettings.ticket-printer")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: _ctx.ticketPrintingStatus ? 'primary' : 'default',
                onClick: _cache[3] || (_cache[3] = function ($event) {
                  return _ctx.setTicketPrintingStatus(true);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.enabled")), 1)];
                }),
                _: 1
              }, 8, ["type"]), _createVNode(_component_el_button, {
                type: !_ctx.ticketPrintingStatus ? 'primary' : 'default',
                onClick: _cache[4] || (_cache[4] = function ($event) {
                  return _ctx.setTicketPrintingStatus(false);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.disabled")), 1)];
                }),
                _: 1
              }, 8, ["type"])];
            }),
            _: 1
          }), _ctx.selectedTicketType === _ctx.TicketTypes.Ticket && !_ctx.showLocalPrinters ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                prop: "printer",
                class: "w-100"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _ctx.printerOption.printer,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                      return _ctx.printerOption.printer = $event;
                    }),
                    placeholder: _ctx.$t('select.printer')
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printers, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.printer_id,
                          label: item.printer_name,
                          value: item.printer_id
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })) : _createCommentVNode("", true), _ctx.showLocalPrinters && _ctx.ticketPrintingStatus && _ctx.selectedTicketType !== _ctx.TicketTypes.MiniTicket ? (_openBlock(), _createBlock(_component_el_col, {
            key: 1,
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                prop: "printer",
                class: "w-100"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _ctx.ticketPrinter,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                      return _ctx.ticketPrinter = $event;
                    }),
                    placeholder: _ctx.$t('select.printer')
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePrinters, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.name,
                          label: item.displayName,
                          value: item.name
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("printersettings.label-printer")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: _ctx.labelPrintingStatus ? 'primary' : 'default',
                onClick: _cache[7] || (_cache[7] = function ($event) {
                  return _ctx.setLabelPrintingStatus(true);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.enabled")), 1)];
                }),
                _: 1
              }, 8, ["type"]), _createVNode(_component_el_button, {
                type: !_ctx.labelPrintingStatus ? 'primary' : 'default',
                onClick: _cache[8] || (_cache[8] = function ($event) {
                  return _ctx.setLabelPrintingStatus(false);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.disabled")), 1)];
                }),
                _: 1
              }, 8, ["type"])];
            }),
            _: 1
          }), _ctx.labelPrintingStatus ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                prop: "label-printer",
                class: "w-100"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _ctx.labelPrinter,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
                      return _ctx.labelPrinter = $event;
                    }),
                    placeholder: _ctx.$t('select.printer')
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePrinters, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.name,
                          label: item.displayName,
                          value: item.name
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("settings.order-summary-receipt")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: _ctx.orderSummaryReceiptPrintingStatus ? 'primary' : 'default',
                onClick: _cache[10] || (_cache[10] = function ($event) {
                  return _ctx.setOrderSummaryReceiptPrintingStatus(true);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.enabled")), 1)];
                }),
                _: 1
              }, 8, ["type"]), _createVNode(_component_el_button, {
                type: !_ctx.orderSummaryReceiptPrintingStatus ? 'primary' : 'default',
                onClick: _cache[11] || (_cache[11] = function ($event) {
                  return _ctx.setOrderSummaryReceiptPrintingStatus(false);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.disabled")), 1)];
                }),
                _: 1
              }, 8, ["type"])];
            }),
            _: 1
          }), _ctx.orderSummaryReceiptPrintingStatus ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                prop: "label-printer",
                class: "w-100"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _ctx.orderSummaryReceiptPrinter,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
                      return _ctx.orderSummaryReceiptPrinter = $event;
                    }),
                    placeholder: _ctx.$t('select.printer')
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePrinters, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.name,
                          label: item.displayName,
                          value: item.name
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("printersettings.receipt-printer")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                prop: "receipt-printer",
                class: "w-100"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _ctx.receiptPrinter,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
                      return _ctx.receiptPrinter = $event;
                    }),
                    placeholder: _ctx.$t('select.printer')
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePrinters, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.name,
                          label: item.displayName,
                          value: item.name
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model"])]);
}